/**
 *   Generated file. Do not edit
 */

import { createEnumConverter } from '@iotize/tap/service/core';
import { createEnumArrayConverter } from '@iotize/tap/service/core';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { ArrayConverter } from '@iotize/tap/client/impl';
import { EnumListConverter } from '@iotize/tap/client/impl';
import { CloudPlatform } from './models';

export const cloudPlatform = createEnumConverter<CloudPlatform>(
  CloudPlatform,
  1,
);

export const cloudPlatformArray = createEnumArrayConverter<CloudPlatform>(
  CloudPlatform,
  1,
);
